(function initializeProductPageRedesign() {
  function renderLightboxThumbs(instance, activeIndex = 0) {
    const container = instance?.$refs?.container?.[0];
    if (!container) return;

    let rail = container.querySelector('[data-product-lightbox-thumbs]');

    if (!rail) {
      rail = document.createElement('div');
      rail.className = 'product-media-lightbox__thumbs';
      rail.setAttribute('data-product-lightbox-thumbs', '');

      instance.group.forEach((item, index) => {
        const button = document.createElement('button');
        const image = document.createElement('img');
        const thumbnail = item.opts?.thumb || item.src;

        button.type = 'button';
        button.className = 'product-media-lightbox__thumb';
        button.dataset.lightboxIndex = String(index);
        button.setAttribute('aria-label', `View image ${index + 1}`);
        button.addEventListener('click', () => {
          if (instance.current?.index === index) return;

          // Direct jumps can animate every intermediate slide in Fancybox v3.
          // Use an instant jump so distant thumbnails behave like adjacent ones.
          instance.jumpTo(index, 0);
        });

        image.src = thumbnail;
        image.alt = '';
        image.loading = 'lazy';
        button.appendChild(image);
        rail.appendChild(button);
      });

      container.appendChild(rail);
    }

    rail.querySelectorAll('[data-lightbox-index]').forEach((button) => {
      const isActive = Number(button.dataset.lightboxIndex) === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');

      if (isActive) {
        if (window.innerWidth <= 767) {
          const targetLeft = button.offsetLeft -
            (rail.clientWidth - button.offsetWidth) / 2;
          rail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        } else {
          button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }
    });
  }

  const lightboxOptions = {
    baseClass: 'product-media-lightbox',
    animationEffect: false,
    animationDuration: 0,
    buttons: ['close'],
    arrows: false,
    infobar: false,
    loop: true,
    transitionEffect: false,
    transitionDuration: 0,
    thumbs: {
      autoStart: false
    },
    afterShow(instance, current) {
      renderLightboxThumbs(instance, current.index);
    }
  };

  function bindThumbnailWheel(slider) {
    if (slider.dataset.wheelNavigationBound === 'true') return;

    slider.dataset.wheelNavigationBound = 'true';
    slider.addEventListener('wheel', (event) => {
      if (window.innerWidth < 1025 || !slider.classList.contains('slick-initialized')) return;

      event.preventDefault();
      window.jQuery(slider).slick(event.deltaY > 0 ? 'slickNext' : 'slickPrev');
    }, { passive: false });
  }

  function arrangeProductDetails() {
    const details = document.querySelector('.template-product .product-default .productView-product');
    const tabs = details?.querySelector('.productView-tab');
    const benefits = details?.querySelector('.productView-benefits');
    const worryFree = details?.querySelector('[id*="worry_free_purchase"]');

    if (!tabs || !benefits || !worryFree) return;

    tabs.insertAdjacentElement('afterend', benefits);
    benefits.insertAdjacentElement('afterend', worryFree);
  }

  function bindMobileVerticalGallery(slider) {
    if (slider.dataset.mobileVerticalGalleryBound === 'true') return;

    slider.dataset.mobileVerticalGalleryBound = 'true';
    let startY = 0;
    let currentY = 0;
    let tracking = false;

    slider.addEventListener('touchstart', (event) => {
      if (
        window.innerWidth > 767 ||
        event.touches.length !== 1 ||
        event.target.closest('[data-mobile-product-pagination]')
      ) return;

      startY = event.touches[0].clientY;
      currentY = startY;
      tracking = true;
    }, { capture: true, passive: true });

    slider.addEventListener('touchmove', (event) => {
      if (!tracking || event.touches.length !== 1) return;

      currentY = event.touches[0].clientY;
      if (Math.abs(currentY - startY) > 8) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, { capture: true, passive: false });

    const finish = (event) => {
      if (!tracking) return;

      const distance = currentY - startY;
      tracking = false;

      if (Math.abs(distance) < 45 || !window.jQuery) return;

      event.preventDefault();
      event.stopPropagation();
      window.jQuery(slider).slick(distance < 0 ? 'slickNext' : 'slickPrev');
    };

    slider.addEventListener('touchend', finish, { capture: true, passive: false });
    slider.addEventListener('touchcancel', () => {
      tracking = false;
    }, { capture: true, passive: true });
  }

  function initializeMobileProductPagination() {
    if (window.innerWidth > 767) {
      document
        .querySelectorAll('[data-mobile-product-pagination]')
        .forEach((pagination) => pagination.remove());
      return;
    }

    if (!window.jQuery) return;

    const sliders = document.querySelectorAll(
      '.template-product .product-default .productView-nav[data-image-gallery-main]'
    );

    sliders.forEach((slider) => {
      if (!slider.classList.contains('slick-initialized')) return;

      const $slider = window.jQuery(slider);
      let slick = $slider.slick('getSlick');
      const imageWrapper = slider.closest('.productView-image-wrapper');
      if (!slick || !imageWrapper) return;

      bindMobileVerticalGallery(slider);

      let pagination = imageWrapper.querySelector('[data-mobile-product-pagination]');

      if (!pagination) {
        pagination = document.createElement('div');
        pagination.className = 'productView-mobilePagination';
        pagination.setAttribute('data-mobile-product-pagination', '');
        pagination.setAttribute('aria-label', 'Product images');
        imageWrapper.appendChild(pagination);
      }

      const render = (activeIndex = slick.currentSlide || 0) => {
        if (pagination.childElementCount !== slick.slideCount) {
          pagination.replaceChildren();

          for (let index = 0; index < slick.slideCount; index += 1) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'productView-mobilePaginationDot';
            button.dataset.slideIndex = String(index);
            button.setAttribute('aria-label', `View product image ${index + 1}`);
            button.addEventListener('click', (event) => {
              event.stopPropagation();
              $slider.slick('slickGoTo', index, true);
              render(index);
            });
            pagination.appendChild(button);
          }
        }

        pagination.querySelectorAll('[data-slide-index]').forEach((button) => {
          const isActive = Number(button.dataset.slideIndex) === activeIndex;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'true' : 'false');

          if (isActive) {
            const targetTop = button.offsetTop -
              (pagination.clientHeight - button.offsetHeight) / 2;
            pagination.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
          }
        });
      };

      $slider.off('.mobileProductPagination');
      $slider.on(
        'afterChange.mobileProductPagination reInit.mobileProductPagination',
        (event, currentSlick, currentSlide) => {
          slick = currentSlick;
          render(currentSlide || 0);
        }
      );

      render();
    });
  }

  function initializeMobileProductSheet() {
    const sheet = document.querySelector(
      '.template-product .product-default [data-product-info-sheet]'
    );
    const handle = sheet?.querySelector('[data-product-sheet-handle]');

    if (!sheet || !handle || sheet.dataset.productSheetBound === 'true') return;

    sheet.dataset.productSheetBound = 'true';
    let pointerId = null;
    let startY = 0;
    let currentOffset = 0;
    let previousY = 0;
    let previousTime = 0;
    let velocityY = 0;
    let dragStartedExpanded = false;
    let startSheetTop = 0;
    let didDrag = false;

    const getSheetTop = () => sheet.getBoundingClientRect().top + window.scrollY;
    const isExpanded = () => Math.abs(sheet.getBoundingClientRect().top) < 12;

    const setExpandedState = (expanded) => {
      sheet.classList.toggle('is-expanded', expanded);
      handle.setAttribute('aria-expanded', String(expanded));
      handle.setAttribute(
        'aria-label',
        expanded ? 'Collapse product information' : 'Expand product information'
      );
    };

    const settleSheet = (expand) => {
      const naturalSheetTop = getSheetTop() - currentOffset;
      sheet.classList.add('is-settling');
      sheet.style.setProperty('--product-sheet-drag-y', '0px');

      if (expand) {
        window.scrollTo({ top: naturalSheetTop, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      window.setTimeout(() => {
        sheet.classList.remove('is-settling', 'is-dragging');
        setExpandedState(expand);
      }, 420);
    };

    const finishDrag = () => {
      if (pointerId === null) return;

      const threshold = Math.min(110, window.innerHeight * 0.14);
      const shouldExpand = !dragStartedExpanded &&
        (currentOffset < -threshold || velocityY < -0.45);
      const shouldCollapse = dragStartedExpanded &&
        (currentOffset > threshold || velocityY > 0.45);

      settleSheet(shouldExpand || (dragStartedExpanded && !shouldCollapse));
      pointerId = null;
      currentOffset = 0;
      velocityY = 0;
    };

    const startDrag = (clientY) => {
      startY = clientY;
      previousY = clientY;
      previousTime = performance.now();
      currentOffset = 0;
      velocityY = 0;
      dragStartedExpanded = isExpanded();
      startSheetTop = getSheetTop();
      didDrag = false;
      sheet.classList.remove('is-settling');
      sheet.classList.add('is-dragging');
    };

    const moveDrag = (clientY) => {
      const now = performance.now();
      const deltaY = clientY - startY;
      const allowedDelta = dragStartedExpanded ? Math.max(0, deltaY) : Math.min(0, deltaY);
      const limit = dragStartedExpanded ? window.innerHeight * 0.45 : startSheetTop;

      currentOffset = Math.max(-limit, Math.min(limit, allowedDelta));
      didDrag = didDrag || Math.abs(currentOffset) > 4;
      velocityY = (clientY - previousY) / Math.max(1, now - previousTime);
      previousY = clientY;
      previousTime = now;
      sheet.style.setProperty('--product-sheet-drag-y', `${currentOffset}px`);
    };

    const shouldHandleDrag = (clientY) => {
      const deltaY = clientY - startY;
      return dragStartedExpanded ? deltaY > 0 : deltaY < 0;
    };

    sheet.addEventListener('pointerdown', (event) => {
      if (window.innerWidth > 767 || event.button !== 0 || event.pointerType === 'touch') return;

      pointerId = event.pointerId;
      startDrag(event.clientY);
      sheet.setPointerCapture(pointerId);
    });

    sheet.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId || !shouldHandleDrag(event.clientY)) return;
      moveDrag(event.clientY);
    });

    sheet.addEventListener('pointerup', finishDrag);
    sheet.addEventListener('pointercancel', finishDrag);
    sheet.addEventListener('touchstart', (event) => {
      if (window.innerWidth > 767 || event.touches.length !== 1) return;

      pointerId = 'touch';
      startDrag(event.touches[0].clientY);
    }, { passive: true });
    sheet.addEventListener('touchmove', (event) => {
      if (
        pointerId !== 'touch' ||
        event.touches.length !== 1 ||
        !shouldHandleDrag(event.touches[0].clientY)
      ) return;

      event.preventDefault();
      moveDrag(event.touches[0].clientY);
    }, { passive: false });
    sheet.addEventListener('touchend', finishDrag, { passive: true });
    sheet.addEventListener('touchcancel', finishDrag, { passive: true });
    handle.addEventListener('click', () => {
      if (didDrag || window.innerWidth > 767) {
        didDrag = false;
        return;
      }
      settleSheet(!isExpanded());
    });

    window.addEventListener('scroll', () => {
      if (pointerId === null && window.innerWidth <= 767) {
        setExpandedState(isExpanded());
      }
    }, { passive: true });
  }

  function waitForMobileProductGallery(attempt = 0) {
    initializeMobileProductPagination();

    const gallery = document.querySelector(
      '.template-product .product-default .productView-nav[data-image-gallery-main]'
    );

    if (
      window.innerWidth <= 767 &&
      gallery &&
      !gallery.classList.contains('slick-initialized') &&
      attempt < 40
    ) {
      window.setTimeout(() => waitForMobileProductGallery(attempt + 1), 100);
    }
  }

  function initialize() {
    document
      .querySelectorAll('.template-product .product-default .productView.layout-1 .productView-for')
      .forEach(bindThumbnailWheel);

    document
      .querySelectorAll('.template-product .product-default .tabs-contents .toggle-content.is-active')
      .forEach((content) => content.classList.remove('is-active'));

    document
      .querySelectorAll('.template-product .product-default .tabs-contents .toggleLink.is-open')
      .forEach((link) => link.classList.remove('is-open'));

    arrangeProductDetails();
    waitForMobileProductGallery();
    initializeMobileProductSheet();
  }

  document.addEventListener('DOMContentLoaded', initialize);
  window.addEventListener('load', initialize);
  window.addEventListener('resize', waitForMobileProductGallery);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-product-fancybox="images"]');
    if (!trigger || !window.jQuery?.fancybox) return;

    event.preventDefault();

    const triggers = Array.from(document.querySelectorAll('[data-product-fancybox="images"]'));
    const items = triggers.map((item) => {
      const image = item.querySelector('img');

      return {
        src: item.getAttribute('href'),
        type: 'image',
        opts: {
          thumb: image?.currentSrc || image?.src || ''
        }
      };
    });

    const startIndex = triggers.indexOf(trigger);
    const instance = window.jQuery.fancybox.open(items, lightboxOptions, startIndex);

    renderLightboxThumbs(instance, startIndex);
  });
})();
